export enum CHAT_DATA_TYPE {
    pdf = 'PDF',
    txt = 'TEXT',
    img = 'IMAGE',
    err = 'ERROR',
    link = 'LINK',
    voice = 'VOICE',
    video = 'VIDEO',
}